import React from "react";
import { useTranslation } from "react-i18next";
import { HomeScheduler } from "../../containers/CompanyCalendar/HomeScheduler";

export { Home };

function Home() {
  const { t } = useTranslation();

  return (
    <div className="col-md-12">
      <div className="home-chart row">
        <div></div>
      </div>
      <div className="row">
        <HomeScheduler></HomeScheduler>
      </div>
    </div>
  );
}
